import './styles/normalize.css';
import './styles/base.css';
import 'firebase/app-check';
import 'firebase/functions';

import App from './App';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import firebase from 'firebase/app';
import theme from './theme';

firebase.initializeApp({
  apiKey: 'AIzaSyDwwvAbMRJsweSsk0sFE4v3qvOHZNENO50',
  authDomain: 'littleninos.firebaseapp.com',
  projectId: 'littleninos',
  storageBucket: 'littleninos.appspot.com',
  messagingSenderId: '382713981182',
  appId: '1:382713981182:web:ab1f965cbe207560be9daf',
});

const appCheck = firebase.appCheck();
appCheck.activate('6Lelf6cbAAAAABjrHWxzp-UHcLZ3kKMaQiimuJlI');

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <ThemeProvider theme={theme}>
        <App firebase={firebase} />
      </ThemeProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);
